import React from 'react';
import {StreamBankLink} from "../../StreamBankLink";

export const SampleEventSyncActivityFeedItemDescription = props => {
    
    const getActionTitle = (action) => {
        switch(action) {
            case "update":
            case "updated":
                return "updated";
            case "create":
            case "created":
                return "added";
            default:
                return "synced";
        }
    };

    const { appName, action, userName, link = null, sampleEventLink = null } = props.CustomEventData;

    const userClause = userName ?? 'StreamBank';
    const actionClause = getActionTitle(action);
    const sampleEventLinkClause = sampleEventLink ? <StreamBankLink Context={sampleEventLink} Tool="summary">an event</StreamBankLink> : 'data';
    const recordClause = link ? <a href={link} target="_blank">record</a> : <span>record</span>;

    return <p>
        {userClause} {actionClause} {sampleEventLinkClause} from a {recordClause} in the {appName} Fulcrum App.
    </p>;

}


